import {
  Form,
  Modal,
  Table,
  Button,
  Space,
  notification,
  message,
  Upload,
  Divider,
} from "antd";
import { useContext, useEffect, useState } from "react";
import {
  PlusCircleTwoTone,
  PlusOutlined,
  LoadingOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import { Fetch, Post, Put, Delete } from "../../fetch";
import { Context } from "../../context";
import { convertIdToKey } from "../../utils";

const { Column } = Table;
const { confirm } = Modal;

const ManageProfiles = () => {
  const { apiUrl, token } = useContext(Context);

  const [profiles, setProfiles] = useState([]);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState("Add");
  const [modalVisible, setModalVisible] = useState(false);
  const [profileIconImageLoading, setProfileIconImageLoading] = useState(false);
  const [profileIconUrl, setProfileIconUrl] = useState(null);

  const [form] = Form.useForm();

  const profileIconImageUploadButton = (
    <div>
      <div>
        {profileIconImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload (300X300)</div>
      </div>
    </div>
  );

  const handleProfileIconImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setProfileIconImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      console.log(info.file.response.url);
      setProfileIconImageLoading(false);
      setProfileIconUrl(info.file.response.url + "/public");
      form.setFieldsValue({ profileIcon: info.file.response.url });
    }
  };

  const beforeImageUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("Only JPG and PNG files are allowed");
    }
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isLt2M) {
      message.error("Image must be smaller than 1MB");
    }

    return isJpgOrPng && isLt2M;
  };

  useEffect(() => {
    Fetch(`${apiUrl}/profiles`, token, (result) => {
      const data = convertIdToKey(result.profiles);
      setProfiles(data);
    });
  }, [apiUrl, token, loading]);

  const handleSubmit = async () => {
    setLoading(true);
    const fn = modalType === "Add" ? Post : Put;
    const url =
      modalType === "Add"
        ? `${apiUrl}/profiles`
        : `${apiUrl}/profiles/${profile.key}`;

    const values = await form.validateFields();
    fn(url, token, { ...values }, (result) => {
      if (result.success) {
        notification.success({
          message: "Success",
          description: `${modalType}ed Profile Icon`,
        });
        setLoading(false);
        setModalType("Add");
        form.resetFields();
        setProfile(null);
        setModalVisible(false);
        setProfileIconUrl(null);
      } else {
        notification.error({
          message: "Error",
          description: result["message"],
        });
      }
    });
  };

  const handleDelete = async (id) => {
    confirm({
      title: "Are you sure?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        try {
          Delete(
            `${apiUrl}/profiles/${id}`,
            token,
            (result) => {
              if (result.success) {
                notification.success({
                  message: "Success",
                  description: "Profile Icon deleted successfully",
                });
                setLoading(false);
              }
            },
            () => {
              notification.error({
                message: "Delete ProfileIcon Error",
                description: "Check console for more details",
              });
            }
          );
        } finally {
        }
      },
    });
  };

  const showEditModal = (record) => {
    setModalType("Edit");
    setModalVisible(true);
    setProfile(record);
    setProfileIconUrl(record.profileIcon + "/public");
    form.setFieldsValue(record);
  };

  return (
    <div className="add-content-wrapper">
      <Table dataSource={profiles}>
        <Column
          title="Profile Icon"
          align="center"
          render={(_, record) =>
            record.profileIcon ? (
              <img
                src={record.profileIcon + "/public"}
                height={100}
                width={100}
                alt="Profile Icon"
              />
            ) : (
              ""
            )
          }
        />
        <Column
          title="Action"
          align="center"
          render={(_, record) => {
            return (
              <Space>
                <Button onClick={() => showEditModal(record)}>Edit</Button>
                <Button onClick={() => handleDelete(record.key)}>Delete</Button>
              </Space>
            );
          }}
        />
      </Table>
      {profiles.length <= 20 && (
        <PlusCircleTwoTone
          twoToneColor="#FF0091"
          style={{ fontSize: "48px" }}
          className="add-artist-btn"
          onClick={() => setModalVisible(true)}
        />
      )}
      <Modal
        open={modalVisible}
        onOk={handleSubmit}
        onCancel={() => {
          form.resetFields();
          setModalVisible(false);
          setModalType("Add");
          setProfileIconUrl(null);
        }}
        maskClosable={false}
      >
        <Form form={form}>
          <Form.Item name={"profileIcon"}>
            <Form.Item
              name="profileIcon"
              label="Profile Icon"
              rules={[{ required: true }]}
            >
              <Divider />
              <Upload
                listType="picture-card"
                showUploadList={false}
                action={`${apiUrl}/uploads/fastpixUploads`}
                headers={{
                  authorization: `Bearer ${token}`,
                }}
                beforeUpload={beforeImageUpload}
                onChange={handleProfileIconImageUploadStatusChange}
              >
                {profileIconUrl ? (
                  <img src={profileIconUrl} style={{ width: "100%" }} />
                ) : (
                  profileIconImageUploadButton
                )}
              </Upload>
            </Form.Item>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ManageProfiles;
